import Vue from "vue";
import app from "./app";

let routes = app;


routes = routes.concat([
    // {
    //     path: "*",
    //     component: require("../components/NotFound").default
    // }
]);

export default routes;
